const SPECIAL_CHARS = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/g;

const rules = [
  {
    key: 'minLength',
    test: (pw) => pw.length >= 12,
  },
  {
    key: 'uppercase',
    test: (pw) => (pw.match(/[A-Z]/g) || []).length >= 3,
  },
  {
    key: 'special',
    test: (pw) => (pw.match(SPECIAL_CHARS) || []).length >= 2,
  },
  {
    key: 'noConsecutiveSpecial',
    test: (pw) => !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]{3,}/.test(pw),
  },
];

export function validatePassword(password) {
  return rules.map((rule) => ({
    key: rule.key,
    passed: rule.test(password || ''),
  }));
}

export function isPasswordValid(password) {
  return rules.every((rule) => rule.test(password || ''));
}
